import axios from 'axios';
import { ApiResponse } from '../models/types'; // Assume you have defined ApiResponse elsewhere

export const get = async (url: string, options?: { headers: { Authorization: string } }): Promise<ApiResponse> => {
    try {
        const response = await axios.get<ApiResponse>(url, options);
        return response.data;
    } catch (error) {
        console.error('Error in GET request:', error);
        throw error
    }
};

export const postAny = async (url: string, options: { data?: any; headers?: any }) => {
    try {
        const response = await axios.post(url, options.data, { headers: options.headers });
        return response;
    } catch (error) {
        console.error('Error in POST request:', error);
        throw error;
    }
};

export const post = async (url: string, options: { data?: any; headers?: any }): Promise<ApiResponse>  => {
    try {
        const response = await axios.post(url, options.data, { headers: options.headers });
        return response.data;
    } catch (error) {
        console.error('Error in POST request:', error);
        throw error;
    }
};